import { MenuPoint, MenuPointCallbackAction } from '@agilox/ui-common';
import { FailuresSubMenuUrl, MenuPointUrl, ProcessesSubMenuUrl } from '../../enums';

export const analyticsMenuPoints = {
	aiInsights: {
		name: 'general.menu.ai_insights',
		url: MenuPointUrl.aiInsights,
		icon: 'ai_spark',
		roles: [],
	} as MenuPoint,
	dashboard: {
		name: 'general.menu.boards',
		url: MenuPointUrl.dashboards,
		icon: 'dashboard',
		roles: [],
		submenuLoader: undefined,
	} as MenuPoint,
	processes: {
		name: 'general.menu.processes',
		url: MenuPointUrl.processes,
		icon: 'process',
		roles: [],
		submenus: [
			{
				name: 'processes.tabs.orders',
				url: ProcessesSubMenuUrl.orders,
				roles: [],
			} as MenuPoint,
			{
				name: 'processes.tabs.actions',
				url: ProcessesSubMenuUrl.actions,
				roles: [],
			} as MenuPoint,
		],
	},
	failures: {
		name: 'general.menu.failures',
		url: MenuPointUrl.failures,
		icon: 'failures',
		roles: [],
		submenus: [
			{
				name: 'failures.tabs.overview',
				url: FailuresSubMenuUrl.overview,
				roles: [],
			} as MenuPoint,
			{
				name: 'failures.tabs.visualization',
				url: FailuresSubMenuUrl.visualization,
				roles: [],
			} as MenuPoint,
			{
				name: 'failures.tabs.history',
				url: FailuresSubMenuUrl.history,
				roles: [],
			} as MenuPoint,
		],
	},
	help: {
		name: 'menu.help',
		url: '',
		icon: 'o_quesmark',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.HELP,
	} as MenuPoint,
	logout: {
		name: 'general.logout',
		url: '',
		icon: 'logout',
		roles: [],
		position: 'bottom',
		callback: true,
		callbackAction: MenuPointCallbackAction.LOGOUT,
	} as MenuPoint,
};

export const analyticsMobileMenuPoints = {
	...analyticsMenuPoints,
};
